import { GetDateReq, GetDateRes } from '@gateway.Home'
import { yamadumiApi } from '../yamadumi-api'

/**
 * 日付情報取得
 */
export class GetDateGateway {
  static getDate = async (params: GetDateReq) => {
    return await yamadumiApi.get<GetDateRes>('/api/common/date/list', { ...params })
  }
}
